import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

interface CustomSpinnerProps {
  color: string;
  size: number;
  style?: React.CSSProperties;
}

const CustomSpinner = ({ color, size, style }: CustomSpinnerProps) => {
  return <BeatLoader color={color} size={size} style={style} />;
};

export default CustomSpinner;
